import { Button } from '@material-ui/core'
import React, { useState, useContext, useEffect, useRef } from 'react'
import CustomInput from '../../atoms/Inputs/CustomInput'
import PrimaryButton from '../../atoms/PrimaryButton'
import '../../molecules/ProductCard/ProductCard.css'
import FavouriteCheckbox from '../../atoms/FavoriteCheckbox'
import SecondaryButton from '../../atoms/SecondaryButton'
import { handleRedirectInternal, currencyFormat } from '../../../common/components'
import { useHistory } from 'react-router-dom'
import Popup from '../../organisms/Popup'
import Timer from '../../../common/timer'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import BuyerContext from '../../../context/buyer/buyerContext'
import AuthContext from '../../../context/auth/authContext'

const Bidding = ({ product, phrases, handleClose, wsprice }) => {
    const buyerContext = useContext(BuyerContext)
    const authContext = useContext(AuthContext)
    let { bidConfirm } = buyerContext
    const { isAuthenticated, user } = authContext
    const history = useHistory()

    /** Convert Bid Amount
     * @param {string} type valToFormat = Actual bid amount to formatted amount, formatToVal = Formatted amount to actual value
     */
    const convertBidAmt = (amt, type) => {
        if (type == 'valToFormat') {
            if (amt == '0') return ''
            return amt
                .toString()
                .replace(/,/g, '')
                .replace(/\D/g, '') // replace non-numeric char with empty string
                .replace(/[^\d].+/, '')
                .replace(/\B(?=(\d{3})+(?!\d))/g, ',')
        } else if (type == 'formatToVal') {
            if (amt == '') return 0
            return amt
                .toString()
                .replace(/,/g, '')
                .replace(/[^\d].+/, '')
        }
    }
    const parseSafeNumber = (val, fallback = 0) => {
        const num = parseFloat(
            String(val)
                .replace(/,/g, '')
                .replace(/[^\d.]/g, ''),
        )
        return Number.isNaN(num) ? fallback : num
    }
    const isLineItemAuction = product && product.auctiontype == 'lineitem'
    const isSealedAuction = product && product.auctiontype == 'sealed'
    const lineItemMinBid = isLineItemAuction ? parseSafeNumber(product.next_bid, 0) : 0
    // Existing user's proxy (if any) for this sublot.
    const lineItemCurrentProxyBid = isLineItemAuction ? parseSafeNumber(wsprice, 0) : 0
    // Frontend guard: never allow lowering below current proxy.
    const lineItemEffectiveMinBid = isLineItemAuction
        ? Math.max(lineItemMinBid, lineItemCurrentProxyBid)
        : 0
    const lineItemMinBidInt = parseInt(lineItemEffectiveMinBid)
    const sealedCurrentBid = isSealedAuction ? parseSafeNumber(product.wprice, 0) : 0
    const sealedStartingPrice = isSealedAuction
        ? parseSafeNumber(product.sprice, 0) || parseSafeNumber(product.next_bid, 0)
        : 0
    const sealedHasBids =
        isSealedAuction &&
        (parseInt(product.bid_count || 0, 10) > 0 || sealedCurrentBid > sealedStartingPrice)
    const sealedMinBid = isSealedAuction
        ? sealedHasBids
            ? sealedCurrentBid + 1
            : sealedStartingPrice
        : 0

    const minBidValue = product
        ? product.auctiontype == 'lineitem'
            ? lineItemEffectiveMinBid
            : product.auctiontype == 'sealed'
            ? sealedMinBid
            : product.next_bid
        : 0
    const realtimeNbidValue =
        product && product.auctiontype == 'lineitem'
            ? parseInt(lineItemEffectiveMinBid)
            : product && product.auctiontype == 'sealed'
            ? parseInt(sealedMinBid)
            : parseInt(product.next_bid)

    const validationArray = Yup.object({
        wsprice: Yup.number()
            .min(minBidValue, `Min. Bid $${minBidValue}`)
            .required('Enter Bid Amount'),
    })
    // line item specific variable master_id,
    const formik = useFormik({
        initialValues: {
            wsprice: parseInt(wsprice),
            bidValDisplay: convertBidAmt(wsprice, 'valToFormat'),
            id: product.id,
            auctionType: product.auctiontype,
            bidType: product.bidtype,
            lotType: product.lottype,
            bid_increment: parseInt(product.incrementAmt),
            csvfile: product.csvfile,
            testbid_incre: parseInt(product.incrementAmt),
            realtime_nbid: realtimeNbidValue,
            master_id: product.master_id,
        },
        validationSchema: validationArray,
        enableReinitialize: true,
        onSubmit: (values) => {
            bidConfirm(values)
        },
    })

    const bidInputChangeHandler = (value) => {
        formik.setFieldValue('bidValDisplay', convertBidAmt(value, 'valToFormat'))
        formik.setFieldValue('wsprice', convertBidAmt(value, 'formatToVal'))
    }
    const hasWspriceError = Boolean(formik.errors.wsprice && formik.touched.wsprice)
    const [lineItemHintError, setLineItemHintError] = useState(false)
    const [lineItemHintPulse, setLineItemHintPulse] = useState(false)
    const lineItemHintPulseTimeoutRef = useRef(null)

    const triggerLineItemHintError = () => {
        setLineItemHintError(true)
        setLineItemHintPulse(true)
        if (lineItemHintPulseTimeoutRef.current) {
            clearTimeout(lineItemHintPulseTimeoutRef.current)
        }
        lineItemHintPulseTimeoutRef.current = setTimeout(() => {
            setLineItemHintPulse(false)
        }, 220)
    }

    const [isBuyer, setIsBuyer] = useState(true)
    useEffect(() => {
        if (user) {
            // if user is admin, or user is seller
            // is_emp = 1, is seller
            if (user.admin != '0' || user.is_emp == '1') {
                setIsBuyer(false)
            }
        }
    }, [user])

    useEffect(() => {
        return () => {
            if (lineItemHintPulseTimeoutRef.current) {
                clearTimeout(lineItemHintPulseTimeoutRef.current)
            }
        }
    }, [])

    useEffect(() => {
        if (!isLineItemAuction || formik.submitCount === 0) return

        if (formik.errors.wsprice) {
            triggerLineItemHintError()
        } else {
            setLineItemHintError(false)
            setLineItemHintPulse(false)
        }
    }, [formik.submitCount, isLineItemAuction])

    return (
        <>
            {product ? (
                <>
                    {/* {product.market_status === 'open' ? ( */}
                    <form onSubmit={formik.handleSubmit}>
                        <div className="biddingCnt d-flex justify-content-center align-items-center">
                            {isAuthenticated ? (
                                <>
                                    {product.auctiontype == 'lineitem' ? (
                                        <div>
                                            <div className="lineItemBidAct d-flex justify-content-start align-items-start flex-wrap">
                                                <CustomInput
                                                    size="small"
                                                    label="Enter bid"
                                                    value={formik.values.bidValDisplay}
                                                    name="wsprice"
                                                    inputProps={{
                                                        min: lineItemEffectiveMinBid,
                                                    }}
                                                    onChange={(e) =>
                                                        bidInputChangeHandler(e.target.value)
                                                    }
                                                    // placeholder={
                                                    //     `Min. Bid ` +
                                                    //     currencyFormat(lineItemEffectiveMinBid)
                                                    // }
                                                    min="0"
                                                    type="text"
                                                    error={hasWspriceError}
                                                    helperText={null}
                                                    disabled={
                                                        product.market_status != 'open'
                                                            ? true
                                                            : false
                                                    }
                                                />
                                                {product.market_status != 'open' || !isBuyer ? (
                                                    <PrimaryButton
                                                        type="submit"
                                                        label={phrases.submit}
                                                        disabled="true"
                                                    />
                                                ) : (
                                                    <PrimaryButton
                                                        type="submit"
                                                        label={phrases.submit}
                                                    />
                                                )}
                                            </div>
                                            {product.bidtype != 'sealed' ? (
                                                <div
                                                    style={{
                                                        fontSize: '12px',
                                                        color: lineItemHintError ? '#ff0000' : '',
                                                        textDecoration: lineItemHintError
                                                            ? 'underline'
                                                            : 'none',
                                                        transform: lineItemHintPulse
                                                            ? 'scale(1.08)'
                                                            : 'scale(1)',
                                                        transformOrigin: 'left center',
                                                        transition:
                                                            'transform 0.22s ease, color 0.22s ease',
                                                    }}
                                                >
                                                    {phrases.enter} {lineItemMinBidInt}{' '}
                                                    {product.currency} {phrases.or_more}
                                                </div>
                                            ) : null}
                                        </div>
                                    ) : (
                                        <>
                                            <div>
                                                <PrimaryButton
                                                    type="submit"
                                                    label={phrases.submit}
                                                    onClick={handleClose}
                                                />
                                            </div>
                                            <div className="margin-5">
                                                <SecondaryButton
                                                    label={phrases.cancel}
                                                    onClick={handleClose}
                                                ></SecondaryButton>
                                            </div>
                                        </>
                                    )}
                                </>
                            ) : (
                                <PrimaryButton
                                    label="Login to Bid"
                                    btnSize="small"
                                    onClick={() => handleRedirectInternal(history, 'login')}
                                />
                            )}
                        </div>
                    </form>
                    {/* ) : null} */}
                </>
            ) : null}
        </>
    )
}

export default Bidding
